import { render, staticRenderFns } from "./ModalStudentAdd.vue?vue&type=template&id=7796b016&scoped=true&lang=pug&"
import script from "./ModalStudentAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentAdd.vue?vue&type=style&index=0&id=7796b016&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796b016",
  null
  
)

export default component.exports